<template>
  <div>
    <div class="box box-success">
      <div class="box-header with-border">
        <div class="col-md-12">
          <span class="box-title">{{ $t("common.search") }}</span>
        </div>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                :placeholder="
                  `${$t('service.service_code')}/${$t(
                    'service.serviceList.serviceName'
                  )}`
                "
                v-model="search.serviceName"
                @keydown.enter="onSearchServiceHistory()"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('service.servicePackage.title')"
                v-model="search.servicePackageName"
                @keydown.enter="onSearchServiceHistory()"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <div class="input-group date">
                <div class="input-group-addon">
                  <i class="fa fa-calendar">
                    <label>
                      <span style="margin-left:5px;display:inline-block;"
                        >{{ $t("service_history.date_from") }}:</span
                      >
                    </label>
                  </i>
                </div>
                <date-picker
                  :config="options"
                  :value="search.from_date"
                  v-model="search.from_date"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <div class="input-group date">
                <div class="input-group-addon">
                  <i class="fa fa-calendar">
                    <label>
                      <span style="margin-left:5px;display:inline-block;"
                        >{{ $t("service_history.date_to") }}:</span
                      >
                    </label>
                  </i>
                </div>
                <date-picker
                  :config="options"
                  :value="search.to_date"
                  v-model="search.to_date"
                ></date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 col-md-3 col-lg-3"></div>
          <div class="col-sm-3 col-md-3 col-lg-3"></div>
          <div class="col-sm-3 col-md-3 col-lg-3"></div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="form-group">
              <button
                type="button"
                class="btn btn-labeled btn-success pull-right"
                @click="onSearchServiceHistory()"
              >
                <span class="btn-label">
                  <i class="glyphicon glyphicon-search"></i>
                </span>
                {{ $t("search.search_button") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box box-success">
      <div class="box-body">
        <div class="col-md-12" style="margin-top: 15px">
          <b-table striped hover :items="items" :fields="fields">
            <template #head()="scope">
              <div class="">{{ $t(scope.label) }}</div>
            </template>
            <template #cell(historyaction)="row">
              {{
                $t(
                  getHistoryActionName(
                    row.item.historyaction,
                    row.item.servicePackageData
                  )
                )
              }}
            </template>
            <!-- <template #cell(actions)="row">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-danger dropdown-toggle"
                  data-toggle="dropdown"
                  aria-expanded="true"
                >
                  <i class="fa fa-fw fa-ellipsis-h"></i>
                </button>
                <ul class="dropdown-menu" style="min-width: 50px">
                  <li>
                    <button
                      v-if="
                        GET_ACCOUNT_DATA.id == 1 || has_perm('update_service')
                      "
                      class="btn btn-primary btn-sm"
                      style="margin-left: 6px;"
                      @click="onOpenEditInput(row.item)"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button>
                  </li>
                  <li style="margin-top: 5px">
                    <button
                      v-if="
                        GET_ACCOUNT_DATA.id == 1 || has_perm('delete_service')
                      "
                      class="btn btn-danger btn-sm"
                      style="margin-left: 6px;"
                      @click="onOpenDelete(row.item)"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </template> -->
          </b-table>
          <div class="box-footer clearfix" style="display:contents;">
            <paginator
              :totalItem="paginateData.totalItem"
              :currentPage="paginateData.currentPage"
              :pageSize="paginateData.pageSize"
              :totalPage="paginateData.totalPage"
              @onpaginate="onPagination"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import constantsData from "@/lib/constantsData";
import datePicker from "vue-bootstrap-datetimepicker";

export default {
  components: {
    "date-picker": datePicker,
    paginator: Paginator
  },
  data: () => ({
    search: {
      serviceName: null,
      servicePackageName: null,
      from_date: null,
      to_date: null
    },
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    items: [],
    fields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "serviceCode",
        label: "service.service_code"
      },
      {
        key: "serviceName",
        label: "service.serviceList.serviceName"
      },
      {
        key: "servicePackage",
        label: "service.servicePackage.title"
      },
      {
        key: "userCreated",
        label: "service.userCreated"
      },
      {
        key: "dateCreated",
        label: "common.datetime"
      },
      {
        key: "historyaction",
        label: "common.historyaction"
      }
      // { key: "actions", label: "common.action" }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    serviceHistoryAction: constantsData.serviceHistoryAction,
    servicePackageHistoryAction: constantsData.servicePackageHistoryAction
  }),
  watch: {
    GET_SERVICE_HISTORY_DATA: function() {
      let paginate = this.GET_SERVICE_HISTORY_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.items = [];
      let data = this.GET_SERVICE_HISTORY_DATA.results;
      data.forEach((element, i) => {
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let data = {
          nonumber: nonumber,
          serviceCode: element.service_code,
          serviceName: element.service_name,
          servicePackage: !utils.isNull(element.service_package_data)
            ? element.service_package_data.package_name : null,
          servicePackageData: element.service_package_data,
          historyaction: element.action,
          userCreated: element.user_created_data.full_name,
          dateCreated: utils.formatSqlDate(element.date_created, null, "HH:mm DD/MM/YYYY")
        };
        this.items.push(data);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SERVICE_HISTORY_DATA"
    ])
  },
  methods: {
    onCallbackData: function() {
      this.getServiceHistoryList(1);
    },
    onPagination: function(data) {
      this.getServiceHistoryList(data);
    },
    getServiceHistoryList: function(page) {
      let filter = {
        params: {
          page: page,
          serviceName: utils.getCleanStringValue(this.search.serviceName),
          servicePackageName: utils.getCleanStringValue(this.search.servicePackageName),
          fromDate: utils.formatSqlUtcDate(this.search.from_date, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          toDate: utils.formatSqlUtcEndOfDate(this.search.to_date, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss")
        }
      };
      this.GET_SERVICE_HISTORY(filter);
    },
    getHistoryActionName: function(actionValue, servicePackageData) {
      if (servicePackageData) {
        let index = this.servicePackageHistoryAction.findIndex(
          x => x.value === actionValue
        );
        return index !== -1 ? this.servicePackageHistoryAction[index].text : "";
      } else {
        let index = this.serviceHistoryAction.findIndex(
          x => x.value === actionValue
        );
        return index !== -1 ? this.serviceHistoryAction[index].text : "";
      }
    },
    onSearchServiceHistory: function() {
      this.getServiceHistoryList(1);
    },
    ...mapActions([
      "GET_SERVICE_HISTORY"
    ])
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/Service/ServiceHistoryList.vue